<template>
    <div v-if="data">
        <h3 class="mt-2 mb-3">Safety Program Resolution</h3>

        <template v-if="hasPermission">
            <vx-card noShadow noRound>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="3" vs-lg="3" class="mb-3">
                        <vs-input
                            :value="data.id ? `#${data.id}` : 'Auto Generated'"
                            label="ID"
                            readonly
                            class="w-full"
                        />
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                        <SelectForeign
                            :model="data.reported_by"
                            label="Reported By"
                            placeholder="Auto Filled"
                            :multiple="false"
                            :load_initial="false"
                            :label_keys="['first_name', 'last_name']"
                            :show_id_in_label="true"
                            :endpoint="`${$store.state.apiendpoints.organisation_users}?is_active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :disabled="true"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.resource_allocation">
                            {{ api_errors.resource_allocation.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="5" vs-lg="5" class="mb-3">
                        <SelectForeign
                            :model.sync="data.assigned_reviewers"
                            label="Assgined Incident Managers"
                            placeholder="Type to Search..."
                            :multiple="true"
                            :load_initial="true"
                            :label_keys="['first_name', 'last_name']"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${manager_dropdown()}&is_active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :close_on_select="false"
                            :disabled="true"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.resource_allocation">
                            {{ api_errors.resource_allocation.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="px-0">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                            <label class="vs-input--label block mb-1">Description</label>
                            <vs-textarea v-model="data.resolution_description" :disabled="!(mode == 'e' && (this.editResolution || this.editExternalResolution))"/>
                            <small class="block text-danger mt-1" v-if="api_errors.resolution_description">
                                {{ api_errors.resolution_description.join(', ') }}
                            </small>
                        </vs-col>
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                            <label class="vs-input--label block mb-1">Reported Images</label>
                            <FileSelection
                            :images="data.images"
                            :filter="val => val.image_type == 'p'"
                            :read_only="true"
                            />
                        </vs-col>
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mb-3">
                            <label class="vs-input--label block mb-1" v-if="mode == 'v'">Resolution Images</label>
                            <FileSelection
                                :images.sync="data.images"
                                :filter="val => val.image_type === undefined || val.image_type === null || val.image_type == 'w'"
                                :read_only="!(mode == 'e' && (this.editResolution || this.editExternalResolution))"
                            />
                            <small class="block text-danger mt-1" v-if="api_errors.images">
                                {{ api_errors.images.join(', ') }}
                            </small>
                        </vs-col>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="px-0">
                        <vs-row>
                            <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
                                <label class="vs-input--label block mb-1">Date Created</label>
                                <FormatText :text="data.created_on" format="datetime" />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                </vs-row>
    
                <vs-row class="mt-base" v-if="data.status == 'a'">
                    <vs-col class="text-center">
                        <strong>Note:</strong> This safety program is Assigned to
                        <template v-if="data.resource_allocation == 'e'">
                            {{ data.allocated_resource.first_name }} {{ data.allocated_resource.last_name }} (Vendor), 
                        </template>
                        {{ data.allocated_engineer.first_name }} {{ data.allocated_engineer.last_name }} (Employee).<br/>
                        <template v-if="data.resolution_status_se">
                            Resolution Status (PO):
                            <template v-if="data.resolution_status_se == 'p'">Pending.<br/></template> 
                            <template v-else-if="data.resolution_status_se == 'r'">
                                Rejected, <span v-if="data.resolution_se_by">(By: {{ data.resolution_se_by.first_name }} {{ data.resolution_se_by.last_name }}).</span> <br/>
                                <span><strong class="text-danger">Reject Reason:</strong> {{ data.resolution_comment_se || "No Comment" }}.</span> <br/>
                            </template>
                            <template v-else-if="data.resolution_status_se == 'a'">
                                Approved, <span v-if="data.resolution_se_by">(By: {{ data.resolution_se_by.first_name }} {{ data.resolution_se_by.last_name }}).</span> <br />
                            </template>
                        </template>
                        <template v-if="data.resolution_status">
                            Resolution Status:
                            <template v-if="data.resolution_status == 'p'">Pending.<br/></template>
                            <template v-else-if="data.resolution_status == 'r'">
                                Rejected, <span v-if="data.resolution_by">(By: {{ data.resolution_by.first_name }} {{ data.resolution_by.last_name }}).</span> <br/>
                                <span><strong class="text-danger">Reject Reason:</strong> {{ data.resolution_comment || "No Comment" }}</span> <br/>
                            </template>
                            <template v-else-if="data.resolution_status == 'a'">
                                Approved, <span v-if="data.resolution_by">(By: {{ data.resolution_by.first_name }} {{ data.resolution_by.last_name }}).</span> <br/>
                            </template>
                        </template>
                        <template v-if="data.resolution_ended_on && ['p', 'r'].includes(data.resolution_status)">
                            Resolution End Date: <FormatText :text="data.resolution_ended_on" format="date" />
                        </template>
                    </vs-col>
                </vs-row>
    
                <vs-row class="mt-base" v-if="(mode == 'e' && (this.editResolution || this.editExternalResolution))">
                    <vs-col class="text-center">
                        <vs-button @click="save" :disabled="submit_disabled">
                            Save
                        </vs-button>
                    </vs-col>
                </vs-row>
    
                <vs-row class="mt-base" v-if="show_action_buttons && (reviewResolution || reviewExternalResolution)">
                    <vs-col class="text-center">
                        <vs-button @click="reject" type="filled" color="primary" class="mx-2">
                            Reject
                        </vs-button>
                        <vs-button @click="approve" type="filled" color="primary" class="mx-2">
                            Approve
                        </vs-button>
                    </vs-col>
                </vs-row>
            </vx-card>
            <RejectionPopup :is_active.sync="reject_popup.active" :api_errors="reject_popup.api_errors" :submit="do_reject" />
        </template>
        <template v-else>
            <PermissionDenied />
        </template>
    </div>
</template>

<script>
import FileSelection from "../Issue/Components/FileSelection.vue";
import RejectionPopup from "../Issue/Components/RejectionPopup.vue";
import { Request } from "../../utils/requests";
import moment from 'moment';

export default {

    data() {
        return {

            safety_program_id: this.$route.params.safety_program_id,

            loading: true,
            data: null,

            submit_disabled: false,
            api_errors: {},
            reject_popup: {
                active: false,
                api_errors: {}
            }
        }
    },
    computed: {
        mode () {
            if (!this.data || (this.data.resource_allocation == 'e' && this.data.resolution_status_se == 'r') || !this.data.resolution_status || this.data.resolution_status == 'r') return 'e'
            return 'v'
        },
        show_action_buttons () {
            if (this.mode != 'v') return false

            if (this.data.resolution_status == 'a') return false
            
            // resource allocation external and resolution_status_se is not approved and user is assigned_reviewers then buttons should not be visible to assigned_reviewers
            if (this.data.resource_allocation == 'e' && this.data.resolution_status_se != 'a' && this.data.assigned_reviewers.map(v=>v.id).includes(this.$store.state.organisation.organisation_user.id)) return false

            // resource allocation external and resolution_status_se is not pending and user is allocated engineer then buttons should not be visible to allocated engineer.
            if (this.data.resource_allocation == 'e' && this.data.resolution_status_se != 'p' && this.data.allocated_engineer.id == this.$store.state.organisation.organisation_user.id) return false

            return true
        },
        viewIssue() {
            let user_ids = this.data.assigned_reviewers.map(v=>v.id)
            user_ids.push(this.data.reported_by.id)
            return this.hasAccess('read', `safety_program`, 'any', user_ids)
        },
        viewResolution() {
            return this.hasAccess('read_resolution', `safety_program`, ['all', 'assigned'], [this.data.allocated_engineer.id])
        },
        editResolution() { 
            return this.data.resource_allocation == 'i' && this.hasAccess('edit_resolution', `safety_program`, ['all', 'assigned'], [this.data.allocated_engineer.id]) 
        },
        // checking issue is external and it have read external resolution permission
        viewExternalResolution() {
            return this.data.resource_allocation == 'e' && this.hasAccess('read_external_resolution', `safety_program`, ['all', 'assigned'], [this.data.allocated_resource.id])
        },
        // checking issue is external and it have edit external resolution permission
        editExternalResolution() { 
            return this.data.resource_allocation == 'e' && this.hasAccess('edit_external_resolution', `safety_program`, ['all', 'assigned'], [this.data.allocated_resource.id]) 
        },
        reviewResolution() { 
            return this.hasAccess('review_resolution', `safety_program`, ['all', 'assigned'], this.data.assigned_reviewers.map(v=>v.id))
        },
        reviewExternalResolution() { 
            return this.data.resource_allocation == 'e' && this.hasAccess('review_external_resolution', `safety_program`, ['all', 'assigned'], [this.data.allocated_engineer.id]) 
        },
        hasPermission() {
            return (this.editResolution || this.editExternalResolution || this.viewResolution || this.viewExternalResolution || this.viewIssue)
        }
    },
    watch: {
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (this.safety_program_id) this.load_data()
        },
        load_data() {
            let request_method = 'GET', url = this.$store.state.apiendpoints.safety_program + this.safety_program_id + "/"

            this.$vs.loading()
            this.loading = true

            Request(this, request_method, url).then(
                res => {
                    this.$vs.loading.close()
                    this.loading = false
                    if (res.status != 'a') {
                        return this.$router.push({name: 'safety-program-list'})
                    }
                    this.data = res
                    if (!this.data.resolution_started_on)
                        this.data.resolution_started_on = moment().format('YYYY-MM-DD')
                },
                err => {
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save() {
            let payload = {
                action: 'submit_resolution',
                resolution_description: this.data.resolution_description
            }

            this.api_errors = {}

            if (this.data.images.length == 0 || (
                this.data.images.filter(v => v.image_type == 'w').length == 0
                && this.data.images.filter(v => typeof(v.image) != 'string').length == 0)
             ) {
                this.api_errors = {
                    "images": [
                        "Please select atleast 1 image",
                    ]
                }
                this.$vs.notify({
                    time: 3000,
                    title: 'Error',
                    text: "Please fix the errors and try again!",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
                return
            }

            this.submit_disabled = true
            this.$vs.loading()

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.safety_program_action, this.data.id), null, payload).then(
                async () => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    await this.upload_images(this.safety_program_id)

                    this.$router.push({name: 'safety-program-list'})

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An error occurred while processing your request. Please try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        async upload_images(id) {
            for (let i=0; i < this.data.images.length; i++) {
                this.$set(this.data.images[i], 'status', 'u')
                try {
                    let data = await this.upload_single_image(id, this.data.images[i])
                    this.$set(this.data.images[i], 'status', 'c')
                    if (data != null)
                        this.$set(this.data.images, i, data)
                } catch (e) {
                    this.$set(this.data.images[i], 'status', 'f')
                    throw e
                }
            }
        },
        async upload_single_image(id, image_obj) {

            return new Promise( (resolve, reject) => {
                if (typeof(image_obj.image) == 'string') resolve(null)

                let payload = new FormData()
                payload.append('image', image_obj.image)
                payload.append('image_type', 'w')

                Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.safety_program_image, id), null, payload).then(
                    res => resolve(res),
                    err => reject(err)
                )

            })
        },
        do_reject(data) {
            let payload = {
                action: 'reject_resolution',
                resolution_comment: data.comment
            }

            this.submit_disabled = true
            this.$vs.loading()
            this.reject_popup.api_errors = {}

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.safety_program_action, this.data.id), null, payload).then(
                () => {
                    this.$vs.loading.close()
                    this.submit_disabled = false
                    this.reject_popup.active = false
                    this.reject_popup.api_errors = {}

                    this.$router.push({name: 'safety-program-list'})

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    if (err.error) {
                        this.reject_popup.api_errors = err.error
                        if (this.reject_popup.api_errors.resolution_comment)
                            this.reject_popup.api_errors.comment = this.reject_popup.api_errors.resolution_comment
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An error occurred while processing your request. Please try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                        this.reject_popup.active = false
                    }
                }
            )
        },
        approve() {
            let payload = {
                action: 'approve_resolution'
            }

            this.submit_disabled = true
            this.$vs.loading()

            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.safety_program_action, this.data.id), null, payload).then(
                () => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    this.$router.push({name: 'safety-program-list'})

                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: "Action completed successfully!",
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                err => {
                    this.$vs.loading.close()
                    this.submit_disabled = false

                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: 'Please fix the errors and try again!',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "An error occurred while processing your request. Please try again.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        reject () {
            this.reject_popup.active = true
        },
        manager_dropdown() {
            let permission = []
            permission.push(`review__all__issue_${this.issue_type}`)
            permission.push(`review__assigned__issue_${this.issue_type}`)

            return permission.toString()
        }
    },
    components: {
        RejectionPopup, FileSelection
    }
}
</script>
